import {
  FinalizeLanguageTestSubmissionInput,
  LanguageTestSubmission,
  WithSectionNavigationContext
} from '../../lib/types/models/language-test/language-test-submission'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const finalizeLanguageTestSubmission = ({
  id,
  ...input
}: IdInput<FinalizeLanguageTestSubmissionInput>) => {
  return restApiClient
    .url(constructApiUrl(API.languageTest.finalizeSubmission.url, { submissionId: id }))
    .post<WithSectionNavigationContext<LanguageTestSubmission>>(input)
}
